"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPrimaryFieldId = exports.getVisibleColumns = exports.getViewById = exports.getPermissions = exports.getSelection = exports.getWidgetDatasheetPack = exports.getActiveViewId = exports.getFieldRoleByFieldId = exports.getWidgetDatasheet = exports.getFieldMap = exports.getView = exports.getFieldPermissionMap = exports.getViews = exports.getSnapshot = exports.isCurrentDatasheetActive = void 0;
const core_1 = require("../../../core");
const core_2 = require("../../../core");
const re_reselect_1 = __importDefault(require("re-reselect"));
const reselect_1 = require("reselect");
const isCurrentDatasheetActive = (state, currentDatasheetId) => {
    var _a;
    return currentDatasheetId === ((_a = state.pageParams) === null || _a === void 0 ? void 0 : _a.datasheetId);
};
exports.isCurrentDatasheetActive = isCurrentDatasheetActive;
const getSnapshot = (state, datasheetId) => {
    var _a;
    const dstId = datasheetId || ((_a = state.widget) === null || _a === void 0 ? void 0 : _a.snapshot.datasheetId);
    const datasheet = (0, exports.getWidgetDatasheet)(state, dstId);
    if (!datasheet) {
        return null;
    }
    return datasheet.snapshot;
};
exports.getSnapshot = getSnapshot;
const getViews = (state, datasheetId) => {
    const snapshot = (0, exports.getSnapshot)(state, datasheetId);
    return snapshot === null || snapshot === void 0 ? void 0 : snapshot.meta.views;
};
exports.getViews = getViews;
const getFieldPermissionMap = (state, datasheetId) => {
    var _a;
    const dstId = datasheetId || ((_a = state.widget) === null || _a === void 0 ? void 0 : _a.snapshot.datasheetId);
    const datasheet = (0, exports.getWidgetDatasheet)(state, dstId);
    if (!datasheet) {
        return;
    }
    return datasheet.fieldPermissionMap;
};
exports.getFieldPermissionMap = getFieldPermissionMap;
exports.getView = (0, re_reselect_1.default)([
    (state, _viewId, datasheetId) => (0, exports.getViews)(state, datasheetId),
    exports.getFieldPermissionMap,
    (_state, viewId) => viewId,
    (state) => {
        var _a, _b, _c;
        const mirrorId = (_a = state.widget) === null || _a === void 0 ? void 0 : _a.snapshot.sourceId;
        return (mirrorId === null || mirrorId === void 0 ? void 0 : mirrorId.startsWith('mir')) && ((_c = (_b = state.mirrorMap) === null || _b === void 0 ? void 0 : _b[mirrorId]) === null || _c === void 0 ? void 0 : _c.mirror);
    }
], (views, fieldPermissionMap, viewId, mirror) => {
    var _a;
    if (!views) {
        return;
    }
    const view = views.find(view => view.id == viewId) || views[0];
    if (!view) {
        return;
    }
    let columns = view.columns.filter(column => {
        const fieldRole = core_2.Selectors.getFieldRoleByFieldId(fieldPermissionMap, column.fieldId);
        return fieldRole !== core_2.ConfigConstant.Role.None;
    });
    if (typeof view.displayHiddenColumnWithinMirror === 'boolean' && !view.displayHiddenColumnWithinMirror && mirror) {
        const originViewHiddenColumnIds = columns.filter(item => item.hidden).map(item => item.fieldId) || [];
        const mirrorColumns = (_a = mirror.temporaryView) === null || _a === void 0 ? void 0 : _a.columns;
        const mirrorFilterColumns = mirrorColumns === null || mirrorColumns === void 0 ? void 0 : mirrorColumns.filter(item => {
            return !originViewHiddenColumnIds.includes(item.fieldId);
        });
        if (!mirrorFilterColumns) {
            // If mirrorFilterColumns does not exist, it means that the user has not configured a trial view in the mirror.
            // In this case, only the hidden columns in the original view need to be filtered.
            columns = view.columns.filter(col => !col.hidden);
        }
    }
    return Object.assign(Object.assign({}, view), { columns });
})((state, viewId, datasheetId) => { var _a, _b; return viewId || ((_b = (_a = (0, exports.getViews)(state, datasheetId)) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.id); });
exports.getFieldMap = (0, reselect_1.createSelector)([(state, useDatasheetId) => { var _a; return (_a = (0, exports.getSnapshot)(state, useDatasheetId)) === null || _a === void 0 ? void 0 : _a.meta; }, exports.getFieldPermissionMap], (meta, fieldPermissionMap) => {
    const _fieldMap = {};
    const fieldMap = meta === null || meta === void 0 ? void 0 : meta.fieldMap;
    if (!fieldMap) {
        return;
    }
    if (!fieldPermissionMap) {
        return fieldMap;
    }
    for (const fieldId in fieldMap) {
        const fieldRole = (0, exports.getFieldRoleByFieldId)(fieldPermissionMap, fieldId);
        if (fieldRole === core_1.Role.None) {
            // room-server currently don't do data filter for no permission fields,
            // so do it in selector
            continue;
        }
        _fieldMap[fieldId] = fieldMap[fieldId];
    }
    return _fieldMap;
});
const getWidgetDatasheet = (state, id) => {
    var _a;
    return (_a = (0, exports.getWidgetDatasheetPack)(state, id)) === null || _a === void 0 ? void 0 : _a.datasheet;
};
exports.getWidgetDatasheet = getWidgetDatasheet;
const getFieldRoleByFieldId = (fieldPermissionMap, fieldId) => {
    if (!fieldPermissionMap || !fieldPermissionMap[fieldId]) {
        return null;
    }
    const role = fieldPermissionMap[fieldId].role;
    return role || core_1.Role.None;
};
exports.getFieldRoleByFieldId = getFieldRoleByFieldId;
// Get the currently active view.
const getActiveViewId = (state, id) => {
    var _a, _b;
    const datasheet = (0, exports.getWidgetDatasheet)(state, id);
    const views = datasheet === null || datasheet === void 0 ? void 0 : datasheet.snapshot.meta.views;
    const pageViewId = (_a = state.pageParams) === null || _a === void 0 ? void 0 : _a.viewId;
    if (!views) {
        return pageViewId;
    }
    if (!views.find(item => item.id === pageViewId)) {
        return (_b = views[0]) === null || _b === void 0 ? void 0 : _b.id;
    }
    return pageViewId;
};
exports.getActiveViewId = getActiveViewId;
const getWidgetDatasheetPack = (state, id) => {
    var _a, _b;
    const datasheetId = id || ((_a = state.widget) === null || _a === void 0 ? void 0 : _a.snapshot.datasheetId);
    if (!datasheetId) {
        return null;
    }
    return (_b = state.datasheetMap) === null || _b === void 0 ? void 0 : _b[datasheetId];
};
exports.getWidgetDatasheetPack = getWidgetDatasheetPack;
const getSelection = (state) => {
    var _a;
    return (_a = (0, exports.getWidgetDatasheetPack)(state)) === null || _a === void 0 ? void 0 : _a.client.selection;
};
exports.getSelection = getSelection;
const getPermissions = (state, id) => {
    var _a;
    return (_a = (0, exports.getWidgetDatasheet)(state, id)) === null || _a === void 0 ? void 0 : _a.permissions;
};
exports.getPermissions = getPermissions;
const getViewById = (state, datasheetId, viewId) => {
    var _a, _b;
    const snapshot = (0, exports.getSnapshot)(state, datasheetId);
    if (!snapshot) {
        return null;
    }
    if (((_a = state === null || state === void 0 ? void 0 : state.pageParams) === null || _a === void 0 ? void 0 : _a.mirrorId) && ((_b = state === null || state === void 0 ? void 0 : state.pageParams) === null || _b === void 0 ? void 0 : _b.datasheetId) === snapshot.datasheetId) {
        const mirror = core_2.Selectors.getMirror(state);
        return core_2.Selectors.getTemporaryView(snapshot, viewId, datasheetId, mirror);
    }
    return core_2.Selectors.getTemporaryView(snapshot, viewId, datasheetId);
};
exports.getViewById = getViewById;
const getVisibleColumns = (state, datasheetId, viewId) => {
    var _a;
    const columns = (_a = (0, exports.getViewById)(state, datasheetId, viewId)) === null || _a === void 0 ? void 0 : _a.columns;
    if (!columns) {
        return [];
    }
    const fieldPermissionMap = (0, exports.getFieldPermissionMap)(state, datasheetId);
    return columns.filter(({ fieldId, hidden }) => {
        const fieldRole = core_2.Selectors.getFieldRoleByFieldId(fieldPermissionMap, fieldId);
        return !hidden && fieldRole !== core_2.ConfigConstant.Role.None;
    });
};
exports.getVisibleColumns = getVisibleColumns;
const getPrimaryFieldId = (state, datasheetId) => {
    var _a;
    const snapshot = (0, exports.getSnapshot)(state, datasheetId);
    const view = snapshot === null || snapshot === void 0 ? void 0 : snapshot.meta.views[0];
    return (_a = view === null || view === void 0 ? void 0 : view.columns[0]) === null || _a === void 0 ? void 0 : _a.fieldId;
};
exports.getPrimaryFieldId = getPrimaryFieldId;
